/**
 * Returns `true` when the given logo URL should be treated as the bundled
 * doxy.me default.
 *
 * Returns `false` only for clinic-uploaded custom logos.
 */
export function isDefaultLogo(logoUrl) {
    return (logoUrl == null || logoUrl.length === 0 || logoUrl.startsWith('/assets/'));
}
